import { Button, Typography } from '@mui/material'
import { OverlayState } from '@/hooks/useOverlay'
import { WorkflowStateEvent } from '@/types/workflow-state-events'
import { Dialog, DialogContent, DialogFooter } from '@/components/dialog'

type DeleteWorkflowStateEventDialogProps = {
  overlay: OverlayState
  onDelete: () => void
  workflowStateEvent: WorkflowStateEvent
  isInitialStateOnEnter: boolean
}

export default function DeleteWorkflowStateEventDialog({
  overlay,
  onDelete,
  workflowStateEvent,
  isInitialStateOnEnter,
}: DeleteWorkflowStateEventDialogProps) {
  return (
    <Dialog {...overlay} title="Delete Event" maxWidth="xs">
      <DialogContent>
        <Typography>
          You are about to delete the &quot;{workflowStateEvent.name}&quot;
          event. Are you sure?
        </Typography>

        {isInitialStateOnEnter && (
          <Typography color="error" sx={{ pt: 2 }}>
            This is the initial state in the workflow. Deleting its On Enter
            event removes the gate that waits for the document&apos;s file to
            finish uploading before processing continues.
          </Typography>
        )}
      </DialogContent>

      <DialogFooter>
        <Button variant="text" onClick={overlay.close}>
          Cancel
        </Button>
        <Button onClick={onDelete} variant="contained" color="error">
          Delete
        </Button>
      </DialogFooter>
    </Dialog>
  )
}
